import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';

export const useZones = () => {
  const [zones, setZones] = useState([]);
  const { loading, error, get } = useApi();

  const fetchZones = useCallback(async () => {
    const result = await get('/public/zones');
    
    if (result.success) {
      setZones(result.data.zones || result.data);
    }
    
    return result;
  }, [get]);

  useEffect(() => {
    fetchZones();
  }, [fetchZones]);

  return {
    zones,
    loading,
    error,
    fetchZones,
  };
};

export default useZones;
